export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Final (2)_04.ec31b6d9.jpg";